export const buildFormulaBoxBody = () => {
    return {
        formula_id :document.getElementById('formula_id').value,

        machine: document.getElementById('machine_formula').value,
        observation: document.getElementById('observation_formula').value,

        colorant_1: document.getElementById('select-1').value,
        quantity_1: document.getElementById('quantity_1').value,

        colorant_2: document.getElementById('select-2').value,
        quantity_2: document.getElementById('quantity_2').value,

        colorant_3: document.getElementById('select-3').value,
        quantity_3: document.getElementById('quantity_3').value,

        colorant_4: document.getElementById('select-4').value,
        quantity_4: document.getElementById('quantity_4').value,

        colorant_5: document.getElementById('select-5').value,
        quantity_5: document.getElementById('quantity_5').value,

        colorant_6: document.getElementById('select-6').value,
        quantity_6: document.getElementById('quantity_6').value,

    }
}

export const validateFormulaBody = (body) => {
 

    if(body.machine === null || body.machine === ''){
        throw new Error('El nombramiento de la maquina es erroneo');
    }
    if (
        (body.quantity_1 === '' || parseFloat(body.quantity_1) <= 0.00) &&
        (body.quantity_2 === '' || parseFloat(body.quantity_2) <= 0.00) &&
        (body.quantity_3 === '' || parseFloat(body.quantity_3) <= 0.00) &&
        (body.quantity_4 === '' || parseFloat(body.quantity_4) <= 0.00) &&
        (body.quantity_5 === '' || parseFloat(body.quantity_5) <= 0.00) &&
        (body.quantity_6 === '' || parseFloat(body.quantity_6) <= 0.00)
    ) {
        throw new Error('Al menos un colorante debe tener una cantidad introducida');
    }
}

export const buildColoranBoxBody = () => {
    return {
        cod_colorant :document.getElementById('cod_colorant').value,
        name: document.getElementById('nom_colorant').value,
    }
}

export const buildEditColoranBody = () => {
    return {
        cod_colorant :document.getElementById('cod').value,
        name: document.getElementById('name').value,
    }
}


export const validateColorantBoxBody = (body) => {

    if(body.cod_colorant === null || body.cod_colorant === '' || body.cod_colorant.trim()===''){
        throw new Error('El codigo del color es erroneo');
    }
    if(body.name === null || body.name === '' || body.name.trim()==='') 
    {
        throw new Error('El nombre del colorante es erroneo');
    }
}



